import { create } from "zustand";
import axios from "axios";

export const useAvailablePlansStore = create((set) => ({
  availablePlans: [],
  loadingPlans: false,
  plansError: null,
  fetchAvailablePlans: async () => {
    set({ loadingPlans: true, plansError: null });
    const token = localStorage.getItem("userToken");
    const url = process.env.REACT_APP_API_BASE_URL;
    try {
      const response = await axios.get(`${url}/auth/v1/plans`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      set({ availablePlans: response.data, loadingPlans: false });
    } catch (error) {
      console.error("Error fetching available plans:", error);
      set({
        plansError: "Failed to fetch available plans.",
        loadingPlans: false,
      });
    }
  },
}));
